"use client";

import { ReactNode, useEffect, useState } from "react";
import { Provider } from "react-redux";
import { AppStore, makeStore } from "@/store";
import { PersistGate } from "redux-persist/integration/react";
import type { Persistor } from "redux-persist";
import { TimezoneProvider } from "@/context/timezone-context";

export default function StoreProvider({ children }: { children: ReactNode }) {
  const [store] = useState<AppStore>(() => makeStore());

  // Expose store for E2E tests and Redux DevTools
  useEffect(() => {
    if (store && process.env.NODE_ENV !== "production") {
      (window as unknown as { __store: AppStore }).__store = store;
    }
  }, [store]);

  // If the app hasn't hydrated yet, skip rendering the PersistGate
  return (
    <Provider store={store}>
      {/* __persistor is only undefined during SSR, where PersistGate never bootstraps anyway */}
      <PersistGate loading={null} persistor={store.__persistor as Persistor}>
        <TimezoneProvider>
          {children}
        </TimezoneProvider>
      </PersistGate>
    </Provider>
  );
}
